/* Real Shopify Ajax cart drawer — overrides the legacy demo drawer globally. */
(function(){
  function money(cents){ return (cents/100).toFixed(2) + ' JD'; }
  function els(sel){ return document.querySelectorAll(sel); }

  function updateDots(count){
    els('#cartDot,[data-rcart-count]').forEach(function(d){ d.textContent = count; });
  }

  /* ==================== FREE-GIFT BAR (FREE bottle at 50 JD) ============ */
  var GC = null;
  try {
    var gcEl = document.getElementById('ezb-gift-cfg');
    if(gcEl) GC = JSON.parse(gcEl.textContent);
  } catch(e){ GC = null; }

  var GDIV = null; /* minor-unit divisor for the threshold: 100 or 1000 (JOD) */
  function giftDivisor(cart){
    if(GDIV) return GDIV;
    if(GC && GC.prices && cart && cart.items){
      for(var i=0;i<cart.items.length;i++){
        var dec = GC.prices[String(cart.items[i].variant_id)];
        if(dec && dec > 0){
          GDIV = (cart.items[i].price / dec) > 500 ? 1000 : 100;
          return GDIV;
        }
      }
    }
    return 100; /* safe default, not cached — retried next render */
  }
  function isGiftLine(it){ return GC && String(it.variant_id) === String(GC.gift); }
  function hasAnyBottle(cart){
    if(!GC) return false;
    return cart.items.some(function(it){
      return isGiftLine(it) || (GC.bottles || []).indexOf(it.variant_id) > -1;
    });
  }
  function giftSubtotal(cart){
    return cart.items.reduce(function(s, it){ return isGiftLine(it) ? s : s + it.final_line_price; }, 0);
  }
  var giftBusy = false, giftFailed = false;
  function giftSync(cart){
    if(!GC || !GC.gift || giftBusy || giftFailed) return;
    var div = giftDivisor(cart);
    var goal = (GC.threshold || 50) * div;
    var sub = giftSubtotal(cart);
    var giftIdx = -1;
    cart.items.forEach(function(it, i){ if(isGiftLine(it)) giftIdx = i; });
    if(sub >= goal && giftIdx === -1 && !hasAnyBottle(cart)){
      giftBusy = true;
      fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id: GC.gift, quantity: 1, properties: { _ezb_gift: 'auto' } }] })
      }).then(function(r){
        giftBusy = false;
        if(!r.ok){ giftFailed = true; return; } /* unavailable — stop retrying */
        refresh(false);
      }).catch(function(){ giftBusy = false; giftFailed = true; });
    } else if(sub < goal && giftIdx > -1){
      giftBusy = true;
      fetch('/cart/change.js', {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ line: giftIdx + 1, quantity: 0 })
      }).then(function(){ giftBusy = false; refresh(false); })
        .catch(function(){ giftBusy = false; });
    }
  }
  function paintGiftBar(cart){
    var bar = document.querySelector('[data-rcart-gift]');
    if(!bar || !GC) return;
    bar.hidden = false;
    var div = giftDivisor(cart);
    var goal = (GC.threshold || 50) * div;
    var sub = giftSubtotal(cart);
    var fill = bar.querySelector('[data-rcart-gift-fill]');
    if(fill) fill.style.width = Math.max(0, Math.min(100, (sub/goal)*100)) + '%';
    var goalEl = bar.querySelector('[data-rcart-gift-goal]');
    if(goalEl) goalEl.textContent = (goal/div).toFixed(0) + ' JD — FREE bottle';
    var msg = bar.querySelector('[data-rcart-gift-msg]');
    if(sub >= goal){
      bar.classList.add('unlocked');
      if(msg) msg.innerHTML = '<b>FREE Energyze Bottle unlocked</b> — added to your cart';
    } else {
      bar.classList.remove('unlocked');
      if(msg) msg.innerHTML = 'Add <b>' + ((goal - sub)/div).toFixed(2) + ' JD</b> more for a <b>FREE Energyze Bottle</b>';
    }
  }
  /* ====================================================================== */

  function render(cart){
    var host = document.querySelector('[data-rcart-items]');
    if(!host) return;
    updateDots(cart.item_count);
    var sub = document.querySelector('[data-rcart-subtotal]');
    if(sub) sub.textContent = money(cart.items_subtotal_price);
    if(!cart.items.length){
      host.innerHTML = '<div class="rcart-empty"><b>Your cart is empty.</b><br><small>Your ritual starts with one scoop.</small></div>';
      return;
    }
    host.innerHTML = cart.items.map(function(it, i){
      var gift = isGiftLine(it);
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_120x$1$2') : '';
      return '<div class="rcart-line">'
        + (img ? '<img src="'+img+'" alt="">' : '<span style="width:60px;height:60px;border-radius:10px;background:var(--cream)"></span>')
        + '<div class="rcart-info"><b>'+it.product_title+'</b>'
        + (vt ? '<span class="rcart-flav">Choose your flavor: <b>'+vt+'</b></span>' : '')
        + (gift
            ? '<span class="rcart-giftpill">FREE gift — orders '+((GC && GC.threshold) || 50)+' JD+</span>'
            : '<span class="rcart-qty">'
              + '<button type="button" aria-label="Decrease" onclick="rcartQty('+(i+1)+','+(it.quantity-1)+')">−</button>'
              + '<span>'+it.quantity+'</span>'
              + '<button type="button" aria-label="Increase" onclick="rcartQty('+(i+1)+','+(it.quantity+1)+')">+</button>'
              + '</span>'
              + '<button class="rcart-rm" type="button" onclick="rcartQty('+(i+1)+',0)">Remove</button>')
        + '</div>'
        + '<span class="rcart-price">'+(gift ? '<span class="free">FREE</span>' : money(it.final_line_price))+'</span>'
        + '</div>';
    }).join('');
  }


  /* ---- cross-sell: show products that are NOT already in the cart ---- */
  var CATALOGUE = null;
  function catalogue(){
    if(CATALOGUE) return CATALOGUE;
    var el = document.querySelector('[data-rcart-catalogue]');
    try { CATALOGUE = JSON.parse(el.textContent); } catch(e){ CATALOGUE = []; }
    return CATALOGUE;
  }
  function renderXsell(cart){
    var box = document.querySelector('[data-rcart-xs]');
    var track = document.querySelector('[data-rcart-xs-track]');
    if(!box || !track) return;
    var inCart = {};
    cart.items.forEach(function(i){ inCart[i.product_id] = true; });
    var recs = catalogue().filter(function(p){ return !inCart[p.pid]; });
    if(!cart.items.length || !recs.length){ box.hidden = true; track.innerHTML = ''; return; }
    box.hidden = false;
    track.innerHTML = recs.map(function(p){
      return '<div class="rcart-xs-card">'
        + (p.img ? '<img src="'+p.img+'" alt="" loading="lazy">' : '<span class="rcart-xs-img"></span>')
        + '<span class="rcart-xs-i"><b>'+p.title+'</b><span>'+p.price+'</span></span>'
        + '<button class="rcart-xs-add" type="button" aria-label="Add ' + p.title.replace(/"/g,'') + '" '
        + 'onclick="rcartAdd('+p.id+',this)">'
        + '<svg class="xs-plus" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>'
        + '<svg class="xs-dots" viewBox="0 0 24 24" aria-hidden="true"><circle cx="5.5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="18.5" cy="12" r="1.5"/></svg>'
        + '</button>'
        + '</div>';
    }).join('');
  }
  window.rcartAdd = function(variantId, btn){
    if(btn){ btn.disabled = true; btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: variantId, quantity: 1}]})
    }).then(function(r){
      if(!r.ok) throw 0;
      return refresh(false);
    }).catch(function(){
      if(btn){ btn.disabled = false; btn.classList.remove('is-loading'); }
    });
  };

  function refresh(open){
    return fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        render(cart);
        renderXsell(cart);
        paintGiftBar(cart);
        giftSync(cart);
        if(open){ document.body.classList.add('rcart-open'); }
        return cart;
      });
  }

  window.rcartQty = function(line, qty){
    fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function(r){ return r.json(); }).then(function(c){ render(c); renderXsell(c); paintGiftBar(c); giftSync(c); })
      .catch(function(){ refresh(false); });
  };

  /* Global overrides: every openCart()/closeCart() in the theme now drives the real drawer */
  window.openCart = function(){ refresh(true); };
  window.closeCart = function(){ document.body.classList.remove('rcart-open'); };
  /* called by add-to-cart flows after a successful /cart/add.js */
  window.ezbCartAdded = function(){ refresh(true); };

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') window.closeCart(); });
  /* initial badge sync */
  if(document.readyState !== 'loading') refresh(false);
  else document.addEventListener('DOMContentLoaded', function(){ refresh(false); });
})();
